'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSkipBackward = function IoSkipBackward(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.9 7.5h0.7c0.5 0 0.9 0.4 0.9 0.9v8.9l14.6-9.6c0.2-0.1 0.4-0.2 0.6-0.2 0.7 0 1.3 0.5 1.3 1.3v5l9.2-6.1c0.2-0.2 0.4-0.2 0.6-0.2 0.7 0 1.2 0.6 1.2 1.3v22.4c0 0.8-0.5 1.3-1.2 1.3-0.2 0-0.4-0.1-0.6-0.2l-9.2-6.1v5c0 0.8-0.6 1.3-1.3 1.3-0.2 0-0.4-0.1-0.6-0.2l-14.6-9.6v8.9c0 0.5-0.4 0.9-0.9 0.9h-0.7c-0.5 0-0.9-0.4-0.9-0.9v-23.2c0-0.5 0.4-0.9 0.9-0.9z' })
        )
    );
};

exports.default = IoSkipBackward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/skip-backward.js
// module id = 2893
// module chunks = 168707334958949